import type { Status } from "@/tokens/status";

// IR-1771 problem 2. Ingestion Matrix law: Unknown / Could Not Check is never
// healthy and never zero. `[].every(...)` is true, so an empty or missing
// status list used to read as a green HEALTHY. Health is derived here, once.

export function deriveComponentHealth(
  components: ReadonlyArray<{ status: string }> | null | undefined,
): Status {
  if (!components || components.length === 0) return "unknown";
  return components.every((c) => c.status === "up") ? "healthy" : "warning";
}

export function derivePipelineHealth(
  stages: ReadonlyArray<{ status: string }> | null | undefined,
): Status {
  if (!stages || stages.length === 0) return "unknown";
  if (stages.some((s) => s.status === "critical")) return "critical";
  if (stages.some((s) => s.status === "warning")) return "warning";
  if (stages.some((s) => s.status !== "healthy")) return "unknown";
  return "healthy";
}
